import React from 'react';
import { ActivitySubjectType, createActivity } from '../../model/activity';
import { Form, useChanges } from '../Form/Form';
import { TextField } from '../Form/TextField/TextField';
import { Avatar } from '../Avatar/Avatar';
import { Shortcut } from '../Shortcut/Shortcut';
import { useSubmit } from '../../model/data';
import { handleError } from '../../model/notification';

interface Props {
  subjectType: ActivitySubjectType;
  subjectId: string;
  placeholder: string;
  autofocus?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export interface Reply {
  text?: string;
}

export function ReplyForm({ subjectId, subjectType, placeholder, autofocus, onSubmit, onCancel }: Props): JSX.Element {
  const [model, setModel] = useChanges<Reply>({});
  const [submit, loading] = useSubmit(
    () => createActivity(subjectId, subjectType, model.text || ''),
    (error) => {
      handleError(error);
    },
    () => {
      if (onSubmit) {
        onSubmit();
      }
      setModel({});
    }
  );

  return (
    <div className="activities-form">
      <Form
        model={model}
        onSubmit={() => {
          submit();
        }}
        onInput={(m) => setModel(m)}
      >
        <Avatar rounded></Avatar>
        <TextField
          className="activities__new-comment"
          name="text"
          disabled={loading}
          loading={loading}
          placeholder={placeholder}
          autoFocus={autofocus}
        />
      </Form>

      {onCancel && <Shortcut keys="Escape" overrideInput={true} onInvoke={onCancel}></Shortcut>}
    </div>
  );
}
